import { Button } from "./ui/button";
import { Link } from "./ui/link";

export default function CTA() {
  return (
    <section className="py-20 text-center">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-6">
          Ready to Enhance Your Security?
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Start using PentAGI today and experience the power of AI-driven
          penetration testing.
        </p>
        <Button size="lg" asChild>
          <Link href="/get-started">Get Started with PentAGI</Link>
        </Button>
      </div>
    </section>
  );
}
